export let labelTypes = [
  '商品标签', '用户标签', '检测项标签', '检测结果标签'
]
export let selectLabelTypes = [
  {
    label: '商品标签',
    value: '商品标签'
  }
//   {
//     label: '用户标签',
//     value: '用户标签',
//     disabled: true
//   },
//   {
//     label: '检测项标签',
//     value: '检测项标签',
//     disabled: true
//   }
]
// 页面顶部tag筛选
export let tableTags = [
  {
    label: '商品标签',
    value: 'goods'
  },
  {
    label: '用户标签',
    value: 'user'
  },
  {
    label: '检测项标签',
    value: 'test'
  },
  {
    label: '检测结果标签',
    value: 'result'
  }
]
// 商品标签列表labels
export let goodsTableLables = [
  {
    label: '标签名称',
    value: 'name'
  },
  {
    label: '标签类型',
    value: 'type'
  },
  {
    label: '相关商品（个）',
    value: 'relatedObjectNumber'
  }
]
// 用户标签列表列表label
export let userTableLabels = [
  {
    label: '标签',
    value: 'name'
  },
  {
    label: '标签描述',
    value: 'description'
  },
  {
    label: '分类',
    value: 'businessTag'
  },
  {
    label: '相关商品(个)',
    value: 'relatedObjectNumber'
  }
]
// 检测项标签列表列表label
export let testTableLabels = [
  {
    label: '标签',
    value: 'name'
  },
  {
    label: '相关商品(个)',
    value: 'relatedObjectNumber'
  }
]
